import Tabs from './tabs'
import TabList from './tabList'
import TabNav from './tabNav'
import TabContent from './tabContent'

Tabs.TabList = TabList
Tabs.TabNav = TabNav
Tabs.TabContent = TabContent

export default Tabs